/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: articlesearch.js
 */
$.namespace("SCS.pagination");

SCS.pagination.firstPageLoaded = false;
SCS.pagination.gsaFirstPageLoaded = false;

/**
 * Switch Article results page (Solution results)
 * @param hash Hash/Anchor (#)
 */
SCS.pagination.switchPage = function(hash, resultPerPage, numResults, resultsSelector, selectedResultIdPrefix) {
	var hashPrefix = "#.";
	if (hash.startsWith(hashPrefix) || !this.firstPageLoaded) {
		var pageNumber = (hash && hash.startsWith(hashPrefix)) ? hash.substr(hash.lastIndexOf(".")+1) : "1";
		if(pageNumber.startsWith("$")) {
			pageNumber = 1;
			hash = hash+"."+pageNumber
		}
		// show/hide results page
		var selectedResultId = selectedResultIdPrefix + pageNumber;
		$(resultsSelector).each(function() {
			if (this.id == selectedResultId) {
				$(this).show();
			} else {
				$(this).hide();
			}
		});
		
		// switch page link
		this.switchPageLink('page', pageNumber, numResults, resultPerPage,hash);

		this.firstPageLoaded = true;
	}
};

/**
 * Switch highlighting of page links
 * @param cssPrefix CSS prefix
 */
SCS.pagination.switchPageLink = function(cssPrefix, pageNumber, numResults, resultPerPage, hash) {
	var indexCounter = Math.ceil(parseInt(numResults) / parseInt(resultPerPage));
	
	if(indexCounter > 10)
	{
		for(var i=1; i <= indexCounter; i++)
		{
			$("#pageLink-"+ i + "-counter").hide();
			$("#pageLink-"+ i + "-counter").removeClass("active");
		}

		if(1 <= pageNumber && pageNumber < 7)
		{
			
			for(var i=0; i <= 7; i++)
			{
				$("#pageLink-"+ i + "-counter").show();
			}
			
			$("#pageLink-"+ parseInt(indexCounter-1) + "-counter").show();
			$("#pageLink-"+ indexCounter + "-counter").show();
			$("#pageLink-"+ pageNumber + "-counter").addClass("active");
			$("#lastSpan").show();
			$("#firstSpan").hide();
		}
		else if(indexCounter-7 < pageNumber && pageNumber <= indexCounter)
		{
			for(var i=0; i <= 7; i++)
			{
				$("#pageLink-"+ parseInt(indexCounter-i) + "-counter").show();
			}
			$("#pageLink-"+ 1 + "-counter").show();
			$("#pageLink-"+ 2 + "-counter").show();
			$("#pageLink-"+ pageNumber + "-counter").addClass("active");
			$("#firstSpan").show();
			$("#lastSpan").hide();
		}
		else{
			$("#pageLink-"+ 1 + "-counter").show();
			$("#pageLink-"+ 2 + "-counter").show();
			
			$("#pageLink-"+ parseInt(pageNumber - 1) + "-counter").show();
			$("#pageLink-"+ parseInt(pageNumber - 2) + "-counter").show();
			$("#pageLink-"+ pageNumber + "-counter").addClass("active");
			$("#pageLink-"+ pageNumber+ "-counter").show();
			
			var next1 = parseInt(pageNumber) + 1;
			var next2 = parseInt(pageNumber) + 2;
			
			$("#pageLink-"+ next1 + "-counter").show();
			$("#pageLink-"+ next2 + "-counter").show();
			
			
			$("#pageLink-"+ parseInt(indexCounter-1)+ "-counter").show();
			$("#pageLink-"+ indexCounter + "-counter").show();
			
			$("#firstSpan").show();
			$("#lastSpan").show();
		}
	}
	
	else{
	
		var pageLinksSelector = '.' + cssPrefix + 'link';
		var selectedPageId = cssPrefix + 'Link-' + pageNumber + '-counter';
		$(pageLinksSelector).each(function() {
			if (this.id == selectedPageId) {
				$(this).addClass("active");
			} else {
				$(this).removeClass("active");
			}
		});
	}
	
	var startIndex = ((pageNumber - 1) * resultPerPage) + 1;
	if(numResults >= startIndex + resultPerPage) {
		var next = parseInt(pageNumber) + 1;
		hash = hash.substring(0,hash.lastIndexOf(".")+1) + next;
		$('#pageLinkNext').attr("href", hash);
		$('#pageLinkNext').show();
	} else {
		$('#pageLinkNext').hide();
	}
	if(startIndex - resultPerPage > 0) {	
		var prev = parseInt(pageNumber) - 1;
		hash = hash.substring(0,hash.lastIndexOf(".")+1) + prev;
		$('#pageLinkPrevious').attr("href",hash);
		$('#pageLinkPrevious').show();
	} else {
		$('#pageLinkPrevious').hide();
	}
};



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/clientsidepagination.js
// module id = 339
// module chunks = 0